<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('校对名称')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="date.batchNo" :placeholder="$t('请输入校对名称')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('校对标准')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-card>
                <a-form-model  ref="formModel" :model="formModel" :rules="rules" :colon="false">
                  <a-col :span=12>
                    <a-form-item :label="$t('酸碱度上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ph_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('酸碱度下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ph_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('温度上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.temp_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('温度下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.temp_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('浊度上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ss_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('浊度下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ss_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('余氯上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.fcl_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('余氯下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.fcl_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('溶解氧上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.doo_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('溶解氧下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.doo_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('氧化还原上限')" style="width:190%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.orp_up" :step="0.01" style="width:50%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('氧化还原下限')" style="width:190%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.orp_down" :step="0.01" style="width:50%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('电导率上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ec_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('电导率下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.ec_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('氨氮上限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.nh3n_up" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('氨氮下限')" style="width:150%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.nh3n_down" :step="0.01" style="width:70%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('化学耗氧量下限')" style="width:190%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.chemo_up" :step="0.01" style="width:50%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span=12>
                    <a-form-item :label="$t('化学耗氧量下限')" style="width:190%;" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input-number v-model="formModel.chemo_down" :step="0.01" style="width:50%;" :placeholder="$t('请输入酸碱度上限')"/>
                    </a-form-item>
                  </a-col>
                </a-form-model>
              </a-card>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea
                v-model="date.remark"
                :placeholder="$t('请输入备注')"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'WQCheckBaseStandardForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        rules:{},
        formModel:{},
        date:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/wq/wQCheckBaseStandard/add",
          edit: "/wq/wQCheckBaseStandard/edit",
          queryById: "/wq/wQCheckBaseStandard/queryById"
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        console.log(record);
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.date.batchNo = record.batchNo
        this.date.remark = record.remark
        if(record.checkStandard != undefined) {
        this.formModel = JSON.parse(record.checkStandard)
        };
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.checkStandard = JSON.stringify(this.formModel);
            formData.batchNo = this.date.batchNo
            formData.remark = this.date.remark
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })

          }
         
        })
      }
    }
  }
</script>